import { render, staticRenderFns } from "./ViewOnePublicList.vue?vue&type=template&id=46a51234&scoped=true&"
import script from "./ViewOnePublicList.ts?vue&type=script&lang=ts&"
export * from "./ViewOnePublicList.ts?vue&type=script&lang=ts&"
import style0 from "./ViewOnePublicList.vue?vue&type=style&index=0&id=46a51234&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46a51234",
  null
  
)

export default component.exports